/* import external modules */
import styled from 'styled-components'

export const Logo = styled.div`
  display: inline-flex;
  cursor: pointer;
`
